import { RadioGroup, RadioItem, Stack, TextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from 'src/pages/manage/security-breach/SecurityBreach';

import { nonEmptyString } from '../validation';

export const ActionsTaken = () => {
  const { setValue, watch } = useFormContext<FormValues>();
  const actionTaken = watch('actionTaken');
  return (
    <Stack space="small">
      <Controller
        name="actionTaken"
        render={({ field, fieldState }) => (
          <RadioGroup
            id="security-breach-actions-taken"
            label="Have you taken any actions in response to the issue?"
            message={fieldState.error?.message}
            value={field.value}
            onChange={({ currentTarget: { value } }) =>
              field.onChange(value as 'Yes' | 'No')
            }
          >
            <RadioItem
              label="Yes"
              value="Yes"
              data={{ id: 'security-breach-actions-taken-yes' }}
            />
            <RadioItem
              label="No"
              value="No"
              data={{ id: 'security-breach-actions-taken-no' }}
            />
          </RadioGroup>
        )}
      />

      {actionTaken === 'Yes' && (
        <Controller
          name="actions"
          rules={{
            validate: nonEmptyString("Enter the type of action you've taken."),
          }}
          render={({ field, fieldState }) => (
            <TextField
              required
              characterLimit={255}
              id="security-breach-actions-taken-text"
              onChange={field.onChange}
              label="What actions have you taken in response to the issue?"
              value={field.value}
              onClear={() => setValue('actions', '')}
              message={fieldState.error?.message}
              tone={fieldState.invalid ? 'critical' : undefined}
            />
          )}
        />
      )}
    </Stack>
  );
};
